import { AppLauncher } from '@capacitor/app-launcher'
import { Browser } from '@capacitor/browser'
import { Capacitor } from '@capacitor/core'

const openUrl = async (
  url: string,
  options?: {
    /**
     * Only supported on web
     */
    windowName?: string
    /**
     * If true, the URL will be opened in the app using the deeplink protocol
     */
    forceDeeplinks?: boolean
    /**
     * Only supported on web
     */
    target?: '_self' | '_blank'
  },
) => {
  try {
    if (Capacitor.isNativePlatform()) {
      const { windowName, forceDeeplinks } = options || {}

      if (forceDeeplinks) {
        try {
          await AppLauncher.openUrl({ url })
        } catch (error) {
          console.error('Error opening URL:', error)
          await Browser.open({ url, windowName, presentationStyle: 'popover' })
        }

        return
      }

      // Some URLs fail the canOpen check even though they should work
      // So we try opening with AppLauncher first and fallback to Browser if it fails
      const canOpenUrl = await AppLauncher.canOpenUrl({ url })

      if (canOpenUrl.value) {
        try {
          await AppLauncher.openUrl({ url })
        } catch (error) {
          console.error('Error opening URL:', error)
          await Browser.open({ url, windowName, presentationStyle: 'popover' })
        }
      } else {
        await Browser.open({ url, windowName, presentationStyle: 'popover' })
      }
    } else {
      if (options?.target === '_self') {
        // Only allow safe schemes to prevent XSS via javascript: URLs
        const SAFE_PROTOCOLS = ['http:', 'https:', 'mailto:', 'tel:']
        const parsed = new URL(url, window.location.origin)
        if (!SAFE_PROTOCOLS.includes(parsed.protocol)) return

        window.location.href = url
      } else {
        Browser.open({ url, windowName: options?.windowName })
      }
    }
  } catch (error) {
    console.error('Error opening URL:', error)
  }
}

const openCozo = () => {
  openUrl('https://apps.cozo.be/webportal', { windowName: '_blank' })
}

const openVidis = () => {
  openUrl('https://vidis.vasha.be/prescriptions/overview?lang=nl', {
    windowName: '_blank',
  })
}

export { openCozo, openUrl, openVidis }
